import { render, staticRenderFns } from "./serProList.vue?vue&type=template&id=eb89b63c&"
import script from "./serProList.vue?vue&type=script&lang=js&"
export * from "./serProList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports